import React from 'react';
//
import SwatchesNavController from "./SwatchesNavController";
import ModelPartsNav from "./ModelPartsNav";
import MaterialsNav from "./MaterialsNav";
import FiltersNav from "./FiltersNav";

const MaterialsDropdown = () => {
  
  return (
    <>
      <SwatchesNavController />
    </>
  )
};


export default MaterialsDropdown;




